module.exports = __webpack_public_path__ + "img/energy-fatigue-sidebar.cc0fbe2e.svg";